import(/* webpackMode: "eager" */ "C:\\website\\src\\app\\page.tsx");
